import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTicket: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="ticket, admit, vip"><path d="M21.25 4.75H2.75V9.25C5.5 10 5.5 14 2.75 14.75V19.25H21.25V14.75C18.5 14 18.5 10 21.25 9.25V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 7.75V8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 11.75V12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 15.75V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTicket;
